import React from "react";

const NoteCreated = ({ modalData }) => {
  const new_data = modalData && modalData.new_data;
  console.log(new_data, "new_data")
  if (!new_data) return null;

  const { note_content, note_type} = new_data;

  return (
    <div className="email-activity">
      <div className="email-row">
        <span className="mlabel">Note Type</span>
        <span className="value">{note_type || "—"}</span>
      </div>



      {note_content && (
        <div className="email-body">
          <div className="email-body-header">
            <span className="mlabel">Note Content</span>
          </div>
          <div
            className="ebody-content"
            dangerouslySetInnerHTML={{ __html: note_content }}
          />
        </div>
      )}
    </div>
  );
};

export default NoteCreated;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/activity/NoteCreated.js